export default {
  // Navigation
  'nav.home': 'Home',
  'nav.about': 'About',
  'nav.features': 'Features',
  'nav.partners': 'Partners',
  'nav.testimonials': 'Testimonials',
  'nav.login': 'Login',
  'nav.portal': 'Member Portal',
  
  // Hero
  'hero.title': 'Learn. Earn. Shop. Redeem.',
  'hero.subtitle': 'Transform your learning journey into rewards with HoneyMoneyUnits (HMU)',
  'hero.cta.primary': 'Start Earning HMU',
  'hero.cta.secondary': 'Learn More',
  
  // Stats
  'stats.activeUsers': 'Active Users',
  'stats.hmuEarned': 'HMU Earned',
  'stats.partners': 'Partner Brands',
  'stats.rewards': 'Rewards Redeemed',
  
  // Features
  'features.title': 'How HoneyJar Works',
  'features.learn.title': 'Learn',
  'features.learn.desc': 'Complete educational modules and earn HMU',
  'features.earn.title': 'Earn',
  'features.earn.desc': 'Engage with partner brands and accumulate points',
  'features.shop.title': 'Shop',
  'features.shop.desc': 'Browse exclusive merchandise and partner offers',
  'features.redeem.title': 'Redeem',
  'features.redeem.desc': 'Exchange your HMU for rewards and products',
  'features.levelup.title': 'Level Up',
  'features.levelup.desc': 'Unlock badges, streaks, and exclusive benefits',
  
  // Portal
  'portal.welcome': 'Welcome back',
  'portal.hmuBalance': 'HMU Balance',
  'portal.tierProgress': 'Tier Progress',
  'portal.currentStreak': 'Current Streak',
  'portal.badges': 'Badges Collected',
  'portal.activeMissions': 'Active Missions',
  'portal.partnerOffers': 'Partner Offers',
  'portal.recommendations': 'Personalized Recommendations',
  
  // Missions
  'missions.title': 'Missions',
  'missions.all': 'All',
  'missions.learning': 'Learning',
  'missions.affiliate': 'Affiliate',
  'missions.completed': 'Completed',
  'missions.active': 'Active Missions',
  'missions.completedCount': 'Completed',
  'missions.earned': 'HMUs Earned',
  'missions.timeInvested': 'Time Invested',
  'missions.start': 'Start Mission',
  'missions.continue': 'Continue',
  'missions.completed.btn': 'Completed',
  'missions.referralBonus': 'Referral Bonus',
  'missions.streakBonus': 'Streak Bonus',
  
  // Rewards
  'rewards.title': 'Rewards Catalog',
  'rewards.all': 'All',
  'rewards.bewear': 'B.E. Wear',
  'rewards.digital': 'Digital Products',
  'rewards.partner': 'Partner Offers',
  'rewards.redeem': 'Redeem',
  'rewards.locked': 'Locked',
  'rewards.earnCPV': 'Earn',
  'rewards.earnCCV': 'per conversion',
  'rewards.selectSize': 'Select Size',
  
  // Auth
  'auth.login': 'Login',
  'auth.register': 'Register',
  'auth.email': 'Email',
  'auth.password': 'Password',
  'auth.name': 'Full Name',
  'auth.location': 'Location',
  'auth.referralCode': 'Referral Code (Optional)',
  'auth.welcomeBonus': 'Get 50 HMU Welcome Bonus!',
  'auth.optIn.tracking': 'I agree to activity tracking',
  'auth.optIn.notifications': 'I want to receive notifications',
  'auth.optIn.partnerOffers': 'I want to receive partner offers',
  'auth.noAccount': "Don't have an account?",
  'auth.hasAccount': 'Already have an account?',
  'auth.signUp': 'Sign up',
  'auth.signIn': 'Sign in',
  
  // Footer
  'footer.tagline': 'Empowering learning through rewards',
  'footer.company': 'Company',
  'footer.about': 'About Us',
  'footer.careers': 'Careers',
  'footer.press': 'Press',
  'footer.contact': 'Contact',
  'footer.resources': 'Resources',
  'footer.blog': 'Blog',
  'footer.help': 'Help Center',
  'footer.faq': 'FAQ',
  'footer.legal': 'Legal',
  'footer.privacy': 'Privacy Policy',
  'footer.terms': 'Terms of Service',
  'footer.compliance': 'Compliance',
  'footer.rights': 'All rights reserved',
  'footer.owner': 'Bingham ENT Global Empire',
  
  // Common
  'common.currency': 'HMU',
  'common.days': 'days',
  'common.hours': 'hours',
  'common.minutes': 'minutes',
  'common.loading': 'Loading...',
  'common.error': 'An error occurred',
  'common.success': 'Success!',
};